/**
 * Catálogos fixos de nacionalidade e profissão (consentimento → UY3 string livre).
 * Espelha `CustomerProfileCatalog.cs` no backend do crédito. Manutenção manual nas duas
 * pontas: drift de nacionalidade faz o front aceitar e o backend rejeitar com 422.
 */
export const OCCUPATION_MAX_LENGTH = 120;

/** Rótulo do select que abre o campo de texto livre. Espelha `CustomerProfileCatalog.OccupationOtherLabel`: o backend rejeita esse literal no payload. */
export const OCCUPATION_OTHER_LABEL = 'Outra';

// O backend só valida dois caracteres; a lista impede que o campo aceite texto livre.
export const UF_OPTIONS: readonly string[] =
  'AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO'.split(' ');

export const NATIONALITY_OPTIONS: readonly string[] = [
  'Brasileira',
  'Afegã',
  'Alemã',
  'Angolana',
  'Argentina',
  'Australiana',
  'Austríaca',
  'Belga',
  'Boliviana',
  'Cabo-verdiana',
  'Canadense',
  'Chilena',
  'Chinesa',
  'Colombiana',
  'Coreana',
  'Cubana',
  'Dinamarquesa',
  'Egípcia',
  'Equatoriana',
  'Espanhola',
  'Estadunidense',
  'Filipina',
  'Finlandesa',
  'Francesa',
  'Grega',
  'Guatemalteca',
  'Haitiana',
  'Hondurenha',
  'Húngara',
  'Indiana',
  'Indonésia',
  'Inglesa',
  'Iraniana',
  'Iraquiana',
  'Irlandesa',
  'Israelense',
  'Italiana',
  'Jamaicana',
  'Japonesa',
  'Libanesa',
  'Mexicana',
  'Moçambicana',
  'Nicaraguense',
  'Nigeriana',
  'Norueguesa',
  'Neerlandesa',
  'Paquistanesa',
  'Paraguaia',
  'Peruana',
  'Polonesa',
  'Portuguesa',
  'Russa',
  'Salvadorenha',
  'Síria',
  'Sueca',
  'Suíça',
  'Sul-africana',
  'Surinamesa',
  'Tailandesa',
  'Turca',
  'Ucraniana',
  'Uruguaia',
  'Venezuelana',
  'Vietnamita',
] as const;

/** Opções do select de profissão em `PassoDadosContrato`. Quem não se encontra na lista escolhe `OCCUPATION_OTHER_LABEL` e digita. */
export const OCCUPATION_OPTIONS: readonly string[] = [
  'Administrador(a)',
  'Advogado(a)',
  'Agricultor(a)',
  'Analista de sistemas',
  'Arquiteto(a)',
  'Assalariado',
  'Assistente administrativo',
  'Assistente social',
  'Atendente',
  'Auxiliar de limpeza',
  'Auxiliar de produção',
  'Bancário(a)',
  'Comerciário(a)',
  'Contador(a)',
  'Coordenador(a)',
  'Cuidador(a)',
  'Eletricista',
  'Enfermeiro(a)',
  'Engenheiro(a)',
  'Estudante',
  'Farmacêutico(a)',
  'Garçom / Garçonete',
  'Gerente',
  'Mecânico(a)',
  'Médico(a)',
  'Motorista',
  'Operador(a) de máquina',
  'Pedreiro',
  'Porteiro(a)',
  'Professor(a)',
  'Programador(a)',
  'Recepcionista',
  'Representante comercial',
  'Segurança',
  'Servidor(a) público(a)',
  'Técnico(a)',
  'Vendedor(a)',
] as const;

export function isKnownNationality(value: string): boolean {
  return NATIONALITY_OPTIONS.includes(value);
}

/**
 * Valida a profissão pelo que o backend exige (não-vazia, dentro do limite e diferente do rótulo
 * "Outra"), não pela lista do select: o backend aceita texto livre (só nacionalidade tem catálogo
 * fechado, com risco de drift). Rejeitar o rótulo aqui evita liberar o "Continuar" para tomar 422.
 */
export function isOccupationValid(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.length <= OCCUPATION_MAX_LENGTH && trimmed !== OCCUPATION_OTHER_LABEL;
}
